import axios from 'axios'
// import { Message, MessageBox } from 'element-ui'
// import store from '@/store'
// import { getToken, setToken, removeToken, getCompanyUid } from '@/utils/auth'



// 是否正在刷新的标记
// let isRefreshing = true
//重试队列
// let requests = []
// create an axios instance
const service = axios.create({
  baseURL: 'http://api.jxznzh.cn/mz', //process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 15000 // request timeout
  // withCredentials : true,
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['jwt']为自定义key 请根据实际情况自行修改
 
    // }
    // config.headers['Authorization'] = getToken()
    // // config.removeHeader('Cookie')
    // // config.headers['Cookie'] = ''
    // config.headers['companyUid'] = getCompanyUid() || ''
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    
    if (res.code !== 0) {

      // 系统繁忙
      alert(res.message);
      // Message({
      //   message: res.message,
      //   type: 'error',
      // })

      // 非5xx的错误属于业务错误，留给具体页面处理
      return Promise.reject(res)
    } else {
      // 不报错：接口返回
      return response
    }
  }, error => {
    console.log('err' + error)// for debug
    alert('后台不能连接，请联系系统管理员');
    // Message({
    //   message: '登录连接超时（后台不能连接，请联系系统管理员）',
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  })

export default service
